import { ReactNode } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import WeeklyReportAssignmentBadge from './WeeklyReportAssignmentBadge';

const WeeklyReportPageSection = ({
  title,
  description,
  remaining = 0,
  selectedCount = 0,
  children,
}: {
  title: string;
  description: string;
  remaining?: number;
  selectedCount?: number;
  children: ReactNode;
}) => {
  return (
    <Box as="section" mt={10}>
      <Flex align="center" gap={4} wrap="wrap">
        <Text variant={'urbanistExtraBold'} fontSize="18px" lineHeight={'22px'} color={'text.darkBlue'}>
          {title}
        </Text>
        {(remaining !== 0 || selectedCount > 0) && (
          <WeeklyReportAssignmentBadge isComplete={remaining === 0 && selectedCount > 0}>
            {remaining > 0
              ? `Assign ${remaining} more`
              : remaining < 0
                ? `Over-assigned: Remove ${-remaining}`
                : `${selectedCount} Selected`}
          </WeeklyReportAssignmentBadge>
        )}
      </Flex>
      <Text mt={2} mb={4} fontSize={'14px'} lineHeight="16px" fontWeight={500} color={'text.mediumGray'}>
        {description}
      </Text>
      {children}
    </Box>
  );
};

export default WeeklyReportPageSection;
